import type { CSSProperties } from 'react';

// Styles and colors for the discount row
export const discountRowStyles = {
    container: {
        display: 'flex',
        flex: '1 1 auto',
        columnGap: '4%',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        width: '100%',
        minHeight: '6.25rem'
    } as CSSProperties,

    dropDownContainer: {
        flex: '1 1 0',
        minWidth: 0,
        position: 'relative'
    } as CSSProperties,

    numericInputContainer: {
        flex: '1 1 0',
        minWidth: 0,
        position: 'relative'
    } as CSSProperties,

    removeButtonContainer: {
        flex: '0 0 auto',
        display: 'flex',
        alignItems: 'center',
        paddingTop: '2.5rem'
    } as CSSProperties,

    trashIcon: {
        enabled: {
            cursor: 'pointer',
            opacity: 1
        } as CSSProperties,
        disabled: {
            cursor: 'not-allowed',
            opacity: 0.5
        } as CSSProperties
    },

    errorMessage: {
        color: '#d41e27',
        lineHeight: '115%',
        fontSize: '14px',
        fontWeight: '400'
    } as CSSProperties
};

// Styles and colors for the main slide-out container
export const dealerDiscountsSlideOutStyles = {
    singleRowContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem'
    } as CSSProperties,

    addDiscountButton: {
        border: 'none',
        outline: 'none',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        cursor: 'pointer',
        width: 'max-content'
    } as CSSProperties,

    addDiscountText: {
        fontWeight: '600'
    } as CSSProperties
};

// Color constants for the slide-out
export const dealerDiscountsSlideOutColors = {
    primaryColor: '#005ba8'
} as const;

// Color constants for the discount row
export const discountRowColors = {
    enabledColor: '#005ba8',
    disabledColor: '#ccc'
} as const;
